import {
	ContentCopyRounded,
	DeleteForever,
	EditOutlined,
	RateReview,
	Restore,
	Star,
} from "@mui/icons-material";
import {
	Avatar,
	AvatarGroup,
	Box,
	Button,
	Grid,
	IconButton,
	Rating,
	Stack,
	Switch,
	Typography,
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import { useEffect, useMemo, useState } from "react";

import { debounce } from "lodash";
import CopyToClipboard from "react-copy-to-clipboard";
import { getAllCurations } from "../../apis/Curation";
import { axiosInstance } from "../../config/axios";
import { notify } from "../Playoff/PlayListTable";
import DeleteModal from "./DeleteModal";
// import PinToTopSwitch from "./PinToTopSwitch";
import PinToTopSwitch from "./PinToTopSwitch";
import StatusSwitch from "./StatusSwitch";

import { getAllPlayoffs } from "../../apis/Playoff";
import { getAllUsers } from "../../apis/user";
import { FilterAutocomplete } from "../Form/FilterAutocomplete";
import { FullHeightLoader } from "../Loader/FullHeightLoader";
import ShowPopupSwitch from "./ShowPopupSwitch";

export const CurationListTable = ({ handleDrawerOpen }) => {
	const [data, setData] = useState([]);
	const [page, setPage] = useState(0);
	const [filters, setFilters] = useState({});
	const [loading, setLoading] = useState(true);
	const [rowsCount, setRowsCount] = useState(10);
	const [count, setCount] = useState(0);
	const [sortingValues, setSortingValues] = useState(null);
	const [curation, setCuration] = useState(null);
	const [open, setOpen] = useState(false);
	const [reset, setReset] = useState(false);
	const serializedFilters = JSON.stringify(filters);
	const serializedSortingValues = JSON.stringify(sortingValues);

	useEffect(() => {
		setLoading(true);
		getAllCurations(rowsCount, page + 1, filters, sortingValues)
			.then((res) => {
				setData(res.results);
				setCount(res.count);
			})
			.finally(() => {
				setLoading(false);
			});
	}, [page, rowsCount, filters, sortingValues]);

	// Reset page to 0 if filters or sortingValues change
	useEffect(() => {
		setPage(0);
	}, [rowsCount, serializedFilters, serializedSortingValues]);

	const handleReset = () => {
		setFilters({});
		setReset(true);
		setPage(0);
	};

	const handleDelete = async () => {
		await axiosInstance.delete(`/communitylist/${curation?.id}`);
		getAllCurations(rowsCount, page + 1, filters, sortingValues).then(
			(res) => {
				setData(res.results);
				setCount(res.count);
			}
		);
		setOpen(false);
	};

	const handleChange = useMemo(
		() => debounce((name, item) => {
			if (item) {
				setFilters((prev) => ({ ...prev, [name]: item?.id }));
			}
		}, 500),
		[]
	);

	const handleSearchChange = useMemo(
		() => debounce((searchText) => {
			setFilters((prev) => ({ ...prev, title: searchText }));
		}, 500),
		[]
	);

	useEffect(() => {
		return () => {
			handleChange.cancel();
			handleSearchChange.cancel();
		};
	}, [handleChange, handleSearchChange]);

	const columns = [
		{
			name: "id",
			label: "Id",
			options: {
				filter: false,
				sort: true,
				setCellProps: () => ({ sx: { textAlign: "right" } }),
				// customBodyRender: (value, tableMeta, updateValue) => {
				// 	// console.log("yes", tableMeta);
				// 	return tableMeta.rowIndex + 1;
				// },
			},
		},
		{
			name: "slug",
			label: "Slug",
			options: {
				filter: false,
				sort: true,

				customBodyRender: (value) => {
					return (
						<Box
							sx={{
								display: "flex",
								flexDirection: "row",
								alignItems: "center",
							}}
						>
							<Typography variant="p" component={"p"}>
								{value}
							</Typography>

							<CopyToClipboard
								text={value}
								onCopy={() => notify("copied")}
							>
								<IconButton size="small" color="primary">
									<ContentCopyRounded />
								</IconButton>
							</CopyToClipboard>
						</Box>
					);
				},
			},
		},
		{
			name: "title",
			label: "Title",
			options: {
				filter: false,
				sort: true,
				customBodyRender: (value) => {
					return (
						<Box
							sx={{
								display: "flex",
								flexDirection: "row",
								alignItems: "center",
							}}
						>
							<Typography variant="p" component={"p"}>
								{value}
							</Typography>

							<CopyToClipboard
								text={value}
								onCopy={() => notify("copied")}
							>
								<IconButton size="small" color="primary">
									<ContentCopyRounded />
								</IconButton>
							</CopyToClipboard>
						</Box>
					);
				},
			},
		},
		{
			name: "image",
			label: "Collage",
			options: {
				filter: false,
				sort: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					// console.log("yes", value);
					return (
						<Avatar
							alt="List Logo"
							variant="square"
							sx={{
								width: 100,
								height: 100,
								objectFit: "fill",
							}}
							src={value?.file}
						/>
					);
				},
			},
		},
		{
			name: "owner",
			label: "Curator",
			options: {
				filter: false,
				sort: true,
				filterType: "custom",
				// customFilterListOptions: {
				// 	update: (filterList, filterPos, index) => {
				// 		// console.log("update");
				// 		// console.log(filterList, filterPos, index);
				// 		return filterList;
				// 	},
				// },

				customBodyRender: (value, tableMeta, updateValue) => {
					// console.log("yes", value);
					return (
						<Stack direction={"row"} alignItems={"center"}>
							<Avatar
								alt="List Logo"
								// variant="square"
								// sx={{
								//     width: 150,
								//     height: 150,
								//     objectFit: "fill",
								// }}
								src={value.image?.file}
							/>
							<Typography variant="p" ml={1}>
								{" "}
								{value.name}
							</Typography>
						</Stack>
					);
				},
			},
		},
		{
			name: "tag_in_insta",
			label: "Tag in Insta",
			options: {
				filter: false,
				sort: false,
				// display: "true",
				// filterType: "custom",
				// // customFilterListOptions: {
				// // 	update: (filterList, filterPos, index) => {
				// // 		// console.log("update");
				// // 		// console.log(filterList, filterPos, index);
				// // 		return filterList;
				// // 	},
				// // },

				customBodyRender: (value, tableMeta, updateValue) => {
					// console.log("yes", value);
					return (
						<Switch
							checked={value}
							onChange={(event) => {
								event.preventDefault();
							}}
							inputProps={{
								"aria-label": "controlled",
							}}
						/>
					);
				},
			},
		},
		{
			name: "",
			label: "Insta Handle",
			options: {
				filter: false,
				sort: false,
				// display: "true",
				// filterType: "custom",
				// // customFilterListOptions: {
				// // 	update: (filterList, filterPos, index) => {
				// // 		// console.log("update");
				// // 		// console.log(filterList, filterPos, index);
				// // 		return filterList;
				// // 	},
				// // },

				customBodyRender: (value, tableMeta, updateValue) => {
					const row = data[tableMeta.rowIndex].owner;
					return row.insta_handle;
					// return <Switch
					// checked={value}
					// onChange={(event) => {
					// 	event.preventDefault();
					// }}
					// inputProps={{
					// 	"aria-label": "controlled",
					// }}
					// />
				},
			},
		},
		{
			name: "playoff",
			label: "Playoff",
			options: {
				sort: true,
				display: "true",
				filterType: "custom",
				// customFilterListOptions: {
				// 	update: (filterList, filterPos, index) => {
				// 		// console.log("update");
				// 		// console.log(filterList, filterPos, index);
				// 		return filterList;
				// 	},
				// },

				customBodyRender: (value, tableMeta, updateValue) => {
					// console.log("yes", value);
					return value.title;
				},
			},
		},
		{
			name: "products",
			label: "Products",
			options: {
				filter: false,
				sort: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					// console.log("yes", value);
					return (
						<AvatarGroup
							sx={{
								justifyContent: "center",
							}}
							total={value?.length}
						>
							{value.slice(0, 3).map((p, i) => (
								<Avatar
									key={`prod-${i}`}
									alt={p.name}
									src={p.image.file}
								/>
								//<p>{p.image.file}</p>
							))}
						</AvatarGroup>
					);
				},
			},
		},
		{
			name: "avg_rating",
			label: "Ratings",
			options: {
				filter: false,
				sort: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
						<Stack
							direction={"row"}
							spacing={1}
							alignItems="center"
						>
							<Rating
								name="text-feedback"
								value={value.avg_rating / 2}
								readOnly
								// size="large"
								// precision={0.5}
								emptyIcon={
									<Star
										style={{ opacity: 0.55 }}
										fontSize="inherit"
									/>
								}
							/>
							<Typography
								variant="body"
								display="block"
								gutterBottom
								mb={0}
							// ml={1}
							>
								(
								{data[tableMeta.rowIndex].ratings
									? data[tableMeta.rowIndex].ratings
									: 0}
								)
							</Typography>
						</Stack>
					);
				},
			},
		},
		{
			name: "created_at",
			label: "Created At",
			options: {
				filter: false,
				sort: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					return new Date(value).toString().substring(4, 24);
				},
			},
		},
		{
			name: "active",
			label: "Toggles",
			options: {
				filter: false,
				sort: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					const curation = data[tableMeta.rowIndex];
					return (
            <Stack direction={"column"}>
              <Stack
                direction={"row"}
                justifyContent={"center"}
                alignItems={"center"}
                sx={{
                  border: "1px solid",
                  borderColor: "divider", // uses theme.palette.divider
                  borderRadius: 2, // optional
                  p: 1,
                }}
              >
                <Typography>Show </Typography>
                <StatusSwitch value={value} curation={curation} />
              </Stack>
              <Stack
                direction={"row"}
                justifyContent={"center"}
                alignItems={"center"}
                sx={{
                  border: "1px solid",
                  borderColor: "divider", // uses theme.palette.divider
                  borderRadius: 2, // optional
                  p: 1, // optional padding
                  my: 1,
                }}
              >
                <Typography>Pin to Top</Typography>
                <PinToTopSwitch
                  value={curation.pin_to_top}
                  curation={curation}
                />
              </Stack>
              {curation.is_popup_playoff && (
                <Stack
                  direction={"row"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  sx={{
                    border: "1px solid",
                    borderColor: "divider", // uses theme.palette.divider
                    borderRadius: 2, // optional
                    p: 1, // optional padding
                    my: 1,
                  }}
                >
                  <>
                    <Typography>Show in Popup</Typography>
                    <ShowPopupSwitch
                      value={curation.show_in_popup}
                      curation={curation}
                    />
                  </>
                </Stack>
              )}
            </Stack>
          );
				},
			},
		},
		{
			name: "",
			label: "Action",
			options: {
				filter: false,
				sort: true,
				viewColumns: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
						<Box>
							<IconButton
								color="primary"
								href={`/w86zjruk6q/curation/${data[tableMeta.rowIndex].id
									}/edit/`}
							>
								<EditOutlined />
							</IconButton>
							<IconButton
								color="primary"
								onClick={() =>
									handleDrawerOpen(data[tableMeta.rowIndex])
								}
							>
								<RateReview />
							</IconButton>
							<IconButton
								color="secondary"
								onClick={() => {
									setCuration(data[tableMeta.rowIndex]);
									setOpen(true);
								}}
							>
								<DeleteForever />
							</IconButton>
							<CopyToClipboard
								text={`https://www.grape.town/curation/${data[tableMeta.rowIndex].slug
									}`}
								onCopy={() => notify("copied")}
							>
								<IconButton size="small" color="primary">
									<ContentCopyRounded />
								</IconButton>
							</CopyToClipboard>
						</Box>
					);
				},
			},
		},
	];

	const options = {
		jumpToPage: true,
		selectableRows: "none",
		download: false,
		filter: false,
		filterType: "multiselect",
		serverSide: true,
		print: false,
		count: count,
		page: page,
		rowsPerPage: rowsCount,
		rowsPerPageOptions: [10, 25, 100],
		onChangePage(currentPage) {
			setPage(currentPage);
		},
		onChangeRowsPerPage(numberOfRows) {
			setRowsCount(numberOfRows);
		},
		onSearchChange: handleSearchChange,

		onColumnSortChange: (changedColumn, direction) => {
			setSortingValues(
				direction === "desc" ? `-${changedColumn}` : `${changedColumn}`
			);
			// setPage(0)
			// setSortFields(temp);
		},

		// onTableChange: (action, tableState) => {
		// 	switch (action) {
		// 		case "sort":
		// 			sortTable(tableState.page, tableState.sortOrder);
		// 			break;
		// 		default:
		// 			console.log("action not handled.");
		// 	}
		// },
	};

	return (
		<Grid
			container
			spacing={2}
			alignItems={"center"}
			justifyContent={"flex-end"}
		>
			<Grid item md={4} lg={3}>
				<FilterAutocomplete
					fetchOptions={getAllPlayoffs}
					label={"Playoff"}
					handleChange={handleChange}
					name={"playoff"}
					reset={reset}
					setReset={setReset}
				/>
			</Grid>
			<Grid item md={4} lg={3}>
				<FilterAutocomplete
					fetchOptions={getAllUsers}
					label={"Curator"}
					handleChange={handleChange}
					name={"owner"}
					reset={reset}
					setReset={setReset}
				/>
			</Grid>
			<Grid item>
				<Button
					variant="contained"
					onClick={handleReset}
					startIcon={<Restore />}
				>
					Reset Filters
				</Button>
				{/* <FilterAutocomplete
					fetchOptions={getAllUsers}
					label={"Curator"}
					// handleChange={handleOwnerChange}
				/> */}
			</Grid>

			<Grid item md={12}>
				{loading && <FullHeightLoader />}
				<MUIDataTable
					title={"Curation List"}
					data={data}
					columns={columns}
					options={options}
				/>

				<DeleteModal
					curation={curation}
					setCuration={setCuration}
					setOpen={setOpen}
					open={open}
					handleDelete={handleDelete}
				/>
			</Grid>
		</Grid>
	);
};
